module.exports = __webpack_public_path__ + "static/media/instagram_logo.3ce9c95b.png";